export function _sortByValue(a: { value: string }, b: { value: string }): number {
  return a.value.toLowerCase().localeCompare(b.value.toLowerCase());
}
